/* PricingFAQs.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _23 = "._1yt41r61{padding:var(--_1qq150r)}";
const _22 = "@media not all and (min-width:64rem){._159e1wug{align-self:auto}}";
const _21 = "._1wpz1h6o{align-self:center}";
const _20 = "._p12f1d56{max-width:48rem}";
const _19 = "._2lx21bp4{flex-direction:column}";
const _18 = "._n7zlzgxb{border-bottom:1px solid var(--ds-border,#091e4224)}";
const _17 = "._vwz41tcg{line-height:24px}";
const _16 = "._p12ffacj{max-width:80ch}";
const _15 = "._1yt413x8{padding:0 var(--ds-space-100,8px) var(--ds-space-250,20px)}";
const _14 = "._18u0xy5q{margin-left:var(--ds-space-400,2pc)}";
const _13 = "@media (min-width:64rem){._1il6m7j4:hover{background:var(--ds-background-neutral,#091e420f)}}";
const _12 = "._80omtlke{cursor:pointer}";
const _11 = "._kqswh2mm{position:relative}";
const _10 = "._4cvr1h6o{align-items:center}";
const _9 = "._1bah1yb4{justify-content:space-between}";
const _8 = "._1e0c1txw{display:flex}";
const _7 = "._qtt8glyw{list-style:none}";
const _6 = "._v564szz9{transition:background-color .1s}";
const _5 = "._1yt41oq0{padding:var(--ds-space-300,24px) var(--ds-space-100,8px)}";
const _4 = "@media not all and (min-width:64rem){._1ubypxbi{margin-bottom:var(--ds-space-200,1pc)}}";
const _3 = "._18s8sgro{margin:var(--ds-space-400,2pc) 0 var(--ds-space-300,24px)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import AddCircleIcon from '@atlaskit/icon/glyph/add-circle';
import CrossCircleIcon from '@atlaskit/icon/glyph/cross-circle';
import { media } from '@atlaskit/primitives/responsive';
import { H4, H5, LinkButton } from '@atlassian/mpac-primitives';
import { AppMarketingLabel } from '@atlassian/mpac-types';
import { MarketplaceAppPaymentModel } from '@atlassian/mpac-types/graphql-gateway-types';
import React, { useState } from 'react';
import { PricingHeading } from '../PricingTab.styles';
import getPaidViaAtlassianFAQs from './paidViaAtlassianFAQs';
import getPaidViaPartnerFAQs from './paidViaPartnerFAQs';
import getServerEolFAQs from './serverEolFAQs';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _2 = "._1bsb1osq{width:100%}";
const _ = "._1wyb1j6v{font-size:1rem}";
const Section = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "section",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1wyb1j6v _1bsb1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Section.displayName = 'Section';
}
const newFAQContainerStyle = null;
const PlansFAQHeaderContainer = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18s8sgro _1ubypxbi", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PlansFAQHeaderContainer.displayName = 'PlansFAQHeaderContainer';
}
const FAQQuestion = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6, _7, _8, _9, _10, _11, _12, _13]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt41oq0 _v564szz9 _qtt8glyw _1e0c1txw _1bah1yb4 _4cvr1h6o _kqswh2mm _80omtlke _1il6m7j4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FAQQuestion.displayName = 'FAQQuestion';
}
const StyledLinkButton = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = LinkButton,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_14]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18u0xy5q", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  StyledLinkButton.displayName = 'StyledLinkButton';
}
const FAQAnswer = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_15, _16, _17]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt413x8 _p12ffacj _vwz41tcg", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FAQAnswer.displayName = 'FAQAnswer';
}
const FAQDetail = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_18]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_n7zlzgxb", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FAQDetail.displayName = 'FAQDetail';
}
const headingStyle = null;
const FAQDetailSection = _ref7 => {
  let {
    faq,
    showPlansFAQs
  } = _ref7;
  const {
    key,
    question,
    answer
  } = faq;
  const [show, setShow] = useState(false);
  const onClick = event => {
    event.stopPropagation();
    setShow(!show);
  };
  const getButtonContent = () => {
    if (!showPlansFAQs) {
      return show ? 'Hide' : 'Show';
    }
    return show ? /*#__PURE__*/_jsx(CrossCircleIcon, {
      testId: "".concat(key, "-faq-close-icon"),
      size: "medium",
      label: "close FAQ",
      primaryColor: "var(--ds-icon-subtle, #626F86)"
    }) : /*#__PURE__*/_jsx(AddCircleIcon, {
      testId: "".concat(key, "-faq-open-icon"),
      size: "medium",
      label: "open FAQ",
      primaryColor: "var(--ds-icon-selected, #0C66E4)"
    });
  };
  return /*#__PURE__*/_jsxs(FAQDetail, {
    children: [/*#__PURE__*/_jsxs(FAQQuestion, {
      onClick: onClick,
      children: [/*#__PURE__*/_jsx(H5, {
        as: showPlansFAQs ? 'h3' : 'h4',
        id: key,
        children: question
      }), /*#__PURE__*/_jsx(StyledLinkButton, {
        id: "".concat(key, "-faq-button"),
        testId: "".concat(key, "-faq-button"),
        onClick: onClick,
        "aria-labelledby": "".concat(key, " ").concat(key, "-button"),
        children: getButtonContent()
      })]
    }), /*#__PURE__*/_jsx("div", {
      "data-testid": "".concat(key, "-faq-answer"),
      "aria-live": "polite",
      role: "status",
      "aria-relevant": "all",
      children: show && /*#__PURE__*/_jsx(FAQAnswer, {
        children: answer
      })
    })]
  });
};
const PricingFAQs = _ref8 => {
  let {
    paymentModel,
    hosting,
    compatibleProducts,
    marketingLabels,
    serverSubscriptionApp,
    hasDataCenterVersion,
    byAtlassian,
    showServerEolFAQs,
    serverEolStartDate,
    showPlansFAQs
  } = _ref8;
  const isJSMCompatible = marketingLabels.includes(AppMarketingLabel.CompatibleWithJSM);
  const isJiraSoftwareCompatible = marketingLabels.includes(AppMarketingLabel.CompatibleWithJSW);
  const parentCompatibleProduct = compatibleProducts[0];
  const allPricingFAQs = paymentModel === MarketplaceAppPaymentModel.PaidViaAtlassian ? getPaidViaAtlassianFAQs({
    hosting,
    isJSMCompatible,
    isJiraSoftwareCompatible,
    parentCompatibleProduct,
    serverSubscriptionApp,
    hasDataCenterVersion,
    byAtlassian
  }) : getPaidViaPartnerFAQs();
  const serverEolFaqs = getServerEolFAQs(serverEolStartDate);
  const faqsToShow = showServerEolFAQs ? serverEolFaqs : allPricingFAQs;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8, _19, _20, _21, _22]
    }), /*#__PURE__*/_jsxs(Section, {
      className: ax([showPlansFAQs && "_1e0c1txw _2lx21bp4 _p12f1d56 _1wpz1h6o _159e1wug"]),
      children: [showPlansFAQs ? /*#__PURE__*/_jsx(PlansFAQHeaderContainer, {
        children: /*#__PURE__*/_jsx(PricingHeading, {
          as: "h2",
          children: "Frequently asked questions"
        })
      }) : /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_23]
        }), /*#__PURE__*/_jsx(H4, {
          as: "h3",
          className: ax(["_1yt41r61"]),
          style: {
            "--_1qq150r": ix("var(--ds-space-400, 32px)".concat(" 0"))
          },
          children: "Pricing FAQs"
        })]
      }), faqsToShow.map(faq => /*#__PURE__*/_jsx(FAQDetailSection, {
        faq: faq,
        showPlansFAQs: showPlansFAQs
      }, faq.key))]
    })]
  });
};
export default PricingFAQs;